<template>
  <div class="portal-page-loader" role="status" aria-live="polite" aria-busy="true">
    <span class="portal-loader-spinner" aria-hidden="true"></span>
    <div><strong>{{ label }}</strong><p>Пожалуйста, подождите…</p></div>
  </div>
</template>
<script>
export default { props: { label: { type: String, default: 'Загружаем данные' } } }
</script>
<style scoped>
.portal-page-loader { display: flex; justify-content: center; align-items: center; gap: 18px; min-height: 180px; margin: 18px 0; padding: 24px; border: 1px solid #dce5f1; border-radius: 14px; background: #f8faff; color: #345376; }
.portal-page-loader strong { font-size: 15px; line-height: 1.5; }
.portal-page-loader p { margin: 5px 0 0; color: #7a8ba1; font-size: 13px; }
.portal-loader-spinner { flex: 0 0 38px; height: 38px; box-sizing: border-box; border: 4px solid #dce8f8; border-top-color: #3979c9; border-radius: 50%; animation: portal-loader-spin .8s linear infinite; }
@keyframes portal-loader-spin { to { transform: rotate(360deg); } }
@media (prefers-reduced-motion: reduce) { .portal-loader-spinner { animation: none; } }
</style>
